import { render, staticRenderFns } from "./LiefengCropper.vue?vue&type=template&id=76b8125a&scoped=true&"
import script from "./LiefengCropper.vue?vue&type=script&lang=js&"
export * from "./LiefengCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8125a",
  null
  
)

export default component.exports